export default "__VITE_ASSET__fa064456__"